      
            <div class="modal-header mb-1">
                <button (click)="modalRef.hide()" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="modal-title">Mark as Issued?</div>
                <div class="modal-subtitle">Please handover the QR Memory code to the customer and let them know how it works for a smooth experience.</div>
                <div class="modal-subtitle">Please note you will recieve your commision amount after the profile is activated.</div>
                <button (click)="markAsSold()" type="submit" class="btn primary w-100 mb-3">Mark as Issued</button>
            </div>